import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
/** Width of the sidebar media (avatar/logo); the column is sized to it so it sits flush right. */
export const MEDIA_SIDEBAR_WIDTH = '10.75rem';
/**
 * GitHub-style settings layout: main content on the left, a media sidebar
 * (profile picture, namespace logo) flush with the right edge. On small
 * screens the media moves above the content, left aligned under the heading.
 */
export const MediaSidebarLayout = ({ sidebar, children }) => (_jsxs(Box, { sx: {
        display: 'grid',
        // Splits at lg, not md: with the settings sidebar already taking a column,
        // a second split below ~1040px squeezes the content to nothing.
        gridTemplateColumns: { xs: '1fr', lg: `1fr ${MEDIA_SIDEBAR_WIDTH}` },
        gap: { xs: '1.5rem', lg: '2.5rem' },
        alignItems: 'start'
    }, children: [_jsx(Box, { sx: { minWidth: 0, order: { xs: 2, lg: 1 } }, children: children }), _jsx(Box, { sx: { width: MEDIA_SIDEBAR_WIDTH, order: { xs: 1, lg: 2 } }, children: sidebar })] }));
//# sourceMappingURL=media-sidebar-layout.js.map